// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_je-0";
export var actionModalContentContainer = "_je-1";
export var createTagButton = "_je-2";
export var footerContainer = "_je-7";
export var fullWidthDivider = "_je-3";
export var hasCreateTagButton = "_je-4";
export var noCreateTagButton = "_je-5";
export var tagsContainer = "_je-6";
export var tagsModalContentContainer = "_je-8";